// extracted by mini-css-extract-plugin
export default {"card":"Card_card__o8efi","card_header":"Card_card_header__t0MrM","title":"Card_title__ElwLb"};